import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('integrations');

export const filtering = {
	computed: {
		...mapState(['filters', 'search']),
	},
	methods: {
		/**
		 * Is Visible
		 *
		 * @since 2.4.0
		 *
		 * @param {string} name The provider name.
		 * @param {Array} categories The provider's categories
		 *
		 * @returns {void}
		 */
		isVisible(name, categories) {
			if (this.isFiltering) {
				const filterResult = this.filters.every((f) => {
					return -1 !== categories.indexOf(f);
				});

				if (!filterResult) {
					return false;
				}
			}

			if (this.isSearching) {
				if (!name.toLowerCase().includes(this.search)) {
					return false;
				}
			}

			return true;
		},
	},
};
